import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Client } from '@app/models/client.model';
import { ClientService } from '@app/services/client.service';
import { SecurityService } from '@app/services/security.service';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of } from 'rxjs';

export const clientGuard: CanActivateFn = (route, state) => {
    const clientService: ClientService = inject(ClientService);
    const securityService: SecurityService = inject(SecurityService);
    const router: Router = inject(Router);
    const logger: NGXLogger = inject(NGXLogger);

    return clientService.get().pipe(
        map((client: Client | null) => {
            if (client) {
                logger.debug('[ClientGuard] client session ok, navigation autorisée', client);
                return true;
            }
            securityService.logout();
            router.navigate(['login'], { queryParams: { returnUrl: state.url } });
            return false;
        }),
        catchError(err => {
            logger.debug('[ClientGuard][Erreur] client session ko, navigation refusée', err);
            securityService.logout();
            router.navigate(['login'], { queryParams: { returnUrl: state.url } });
            return of(false);
        }),
    );
};
